/**
 * Migration des clés localStorage de l'ancien préfixe vers le nouveau.
 * Exécutée une seule fois au démarrage — les anciennes clés sont supprimées après copie.
 */

const OLD_PREFIX = "plania_";
const NEW_PREFIX = "palnia_";
const MIGRATION_FLAG = `${NEW_PREFIX}storage_migrated`;

export function migrateStorage(): void {
  if (localStorage.getItem(MIGRATION_FLAG)) return;

  const keysToMigrate: string[] = [];
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key?.startsWith(OLD_PREFIX)) {
      keysToMigrate.push(key);
    }
  }

  for (const oldKey of keysToMigrate) {
    const newKey = oldKey.replace(OLD_PREFIX, NEW_PREFIX);
    const value = localStorage.getItem(oldKey);
    if (value !== null) {
      localStorage.setItem(newKey, value);
    }
    localStorage.removeItem(oldKey);
  }

  localStorage.setItem(MIGRATION_FLAG, "1");
}

/**
 * Supprime le token JWT obsolète du localStorage (migration vers cookies HTTP-only).
 */
export function cleanupLegacyToken(): void {
  localStorage.removeItem("palnia_token");
  localStorage.removeItem("plania_token");
}
